
<template>
  <div>
    <header>
      <Header msg="Header" />
      <SettingsHeader msg="SettingsHeader" />
    </header>
    <main>
      <div class="notify container">
        <ul>
          <li>
            <i class="icon-notifications-large"></i>
          </li>
        </ul>

        <div v-if="bounded === false">
          <ul>
            <li>1. 綁定LINE Notify 訂單通知服務</li>
            <li class="text_s">可在LINE接收訂單的進度與狀態</li>
            <li>
              <a class="btn bind" :href="bindUrl">立即綁定</a>
            </li>
          </ul>

          <ul>
            <li>
              2. 登入LINE
              <br />並選擇您要接受通知的聊天室
            </li>
            <li class="text_s line_notify">「透過1對1聊天接收LINE Notify的通知」</li>
          </ul>

          <ul>
            <li>3. 成功綁定LINE通知</li>
          </ul>
        </div>
        <div v-if="bounded === true">
          <ul>
            <li>LINE Notify 訂單通知服務</li>
            <li class="text_s">可在LINE接收訂單的進度與狀態</li>
            <li class="checked">
              <i class="icon-check"></i> 已綁定LINE通知
            </li>
            <li>
              <a class="btn bind" href="#" v-on:click="testUserNotify()">測試訊息</a>
            </li>
            <li>
              <a class="btn unbind" href="#alert" rel="modal:open">解除綁定</a>
            </li>
          </ul>

          <div id="alert" class="modal notify">
            <ul>
              <li>解除LINE Notify 訂單通知服務？</li>
              <li>
                <a class="btn cancel" href="#" rel="modal:close">取消</a>
                <a class="btn unbind" href="#" rel="modal:close" v-on:click="revokeUserNotify()">確定</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
import Header from "@/components/Header.vue";
import SettingsHeader from "@/components/SettingsHeader.vue";

export default {
  name: "home",
  data() {
    return {
      bounded: null
    };
  },
  components: {
    SettingsHeader,
    Header
  },
  computed: {
    userId() {
      return localStorage.getItem("lineUserId");
    },
    notifyAppId() {
      return GLOBAL_ENV_NOTIFY_APP;
    },
    bindUrl() {
      let url = `${process.env.VUE_APP_APIHOST}/me/line-notify?app_id=${this.notifyAppId}&user_id=${this.userId}&p=${this.$router.currentRoute.query.p}`;
      if (this.$router.currentRoute.query.s) {
        url += `&shop_id=${this.$router.currentRoute.query.s}`;
      }
      
      return url;
    }
  },
  methods: {
    getUserNotify() {
      let self = this;
      fetch(
        `${process.env.VUE_APP_APIHOST}/apis/line-notify?user_id=${self.userId}`
      )
        .then(res => res.json())
        .then(function(response) {
          console.log("the response " + JSON.stringify(response));
          if (response.lineNotify === true) {
            // 有notify

            self.bounded = true;
          } else {
            // 沒有notify

            self.bounded = false;
          }
        })
        .catch(function(e) {
          console.log(e.stack);
        });
    },
    revokeUserNotify() {
      let self = this;

      fetch(`${process.env.VUE_APP_APIHOST}/apis/line-notify/revoke`, {
        method: "POST",
        body: JSON.stringify({ userId: this.userId }),
        headers: {
          "content-type": "application/json"
        }
      })
        .then(res => res.json())
        .then(function(response) {
          self.bounded = false;
        })
        .catch(function(e) {
          console.log(e.stack);
        });
    },
    testUserNotify() {
      fetch(`${process.env.VUE_APP_APIHOST}/apis/line-notify`, {
        method: "POST",
        body: JSON.stringify({ userId: this.userId }),
        headers: {
          "content-type": "application/json"
        }
      })
        .then(res => res.json())
        .then(function(response) {
          console.log("the test response " + JSON.stringify(response));
        })
        .catch(function(e) {
          console.log(e.stack);
        });
    }
  },
  mounted() {
    this.getUserNotify();
  }
};
</script>

<style scoped>
/* @import '../assets/css/theme_default.css'; */
</style>